import { Col, message, Row, Form } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { RolePermissionsCard } from "./components/RolePermissionsCard";
import { RoleFormCard } from "./components/RoleFormCard";
import { useState, useEffect } from "react";
import {
  fetchRoleById,
  updateRoleById,
} from "../../../lib/api/resources/roles";
import { RoleFormValues } from "./RoleCreate";

export const RoleEdit = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [selectedPermissionIds, setSelectedPermissionIds] = useState<string[]>(
    [],
  );

  if (!id) return null;
  const navigate = useNavigate();

  const roleQuery = useQuery({
    queryKey: ["role", id],
    queryFn: async () => fetchRoleById(id),
  });

  useEffect(() => {
    if (roleQuery.data) {
      form.setFieldsValue({
        name: roleQuery.data.name,
        externalSsoGroup: roleQuery.data.externalSsoGroup,
        pending: roleQuery.data.pending,
        dealershipRequired: roleQuery.data.dealershipRequired,
        system: roleQuery.data.system,
      });
      setSelectedPermissionIds(roleQuery.data.permissions || []);
    }
  }, [form, roleQuery.data]);

  const updateRoleMutation = useMutation({
    mutationFn: (data: RoleFormValues) => updateRoleById(id, data),
    onSuccess: () => {
      navigate(`/roles/${id}`);
      message.success("Rol succesvol bijgewerkt");
    },
    onError: () =>
      message.error("Er is een fout opgetreden bij het bijwerken van de rol"),
  });

  const handleFinish = (values: RoleFormValues) => {
    const payload = {
      name: values.name,
      externalSsoGroup: values.externalSsoGroup,
      pending: values.pending || false,
      dealershipRequired: values.dealershipRequired || false,
      system: values.system || false,
      permissions: selectedPermissionIds,
    };
    updateRoleMutation.mutate(payload);
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical">
      <Row gutter={[16, 16]}>
        <Col xxl={{ span: 12 }} span={24}>
          <RoleFormCard
            form={form}
            initialValues={roleQuery.data}
            title="Rol bewerken"
            buttonText="Bewerken"
            loading={roleQuery.isLoading}
            submitting={updateRoleMutation.isPending}
            onFinish={handleFinish}
          />
        </Col>
        <Col xxl={{ span: 12 }} span={24}>
          <RolePermissionsCard
            editMode
            selectedPermissionIds={selectedPermissionIds}
            setSelectedPermissionIds={setSelectedPermissionIds}
          />
        </Col>
      </Row>
    </Form>
  );
};
